export default "__VITE_ASSET__$uD1dlsV__"